module.exports = __webpack_public_path__ + "static/img/wechat.56751e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/wechat.jpg
// module id = sIia
// module chunks = 1